import styled, { css } from 'styled-components'
import { fonts } from './fonts'
import { colors } from '../theme/colors'
import { tokens } from 'app-v2/design-systems/theme/tokens'
import { COLOR, TEXT } from 'app-v2/design-tokens'

const uppercase = css`
    text-transform: ${props => (props.uppercase ? 'uppercase' : 'none')};
`

const text = css`
    display: inline-block;
    color: ${colors.accentuation};
    font-family: ${fonts.flameSansRegular};
    font-size: 16px;
`

const smallText = css`
    display: inline-block;
    color: ${colors.accentuation};
    font-family: ${fonts.flameSansRegular};
    font-size: 14px;
    line-height: 19.6px;
`

const body = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.bodyFontFamily};
    font-size: ${tokens.bodyFontSize}px;
    line-height: ${tokens.bodyLineHeight}px;
    color: ${tokens.bodyFontColor};

    ${({ center }) =>
        center &&
        `
            text-align: center;
        `};
`

const caption = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.captionFontFamily};
    font-size: ${tokens.captionFontSize}px;
    line-height: ${tokens.captionLineHeight}px;
    color: ${tokens.captionFontColor};
`

const extraSmallButton = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.extraSmallButtonFontFamily};
    font-size: ${tokens.extraSmallButtonFontSize}px;
    line-height: ${tokens.extraSmallButtonLineHeight}px;
    padding: ${tokens.extraSmallButtonVerticalPadding}px
        ${tokens.extraSmallButtonHorizontalPadding}px;
`

const smallButton = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.smallButtonFontFamily};
    font-size: ${tokens.smallButtonFontSize}px;
    line-height: ${tokens.smallButtonLineHeight}px;
    padding: ${tokens.smallButtonVerticalPadding}px
        ${tokens.smallButtonHorizontalPadding}px;
`

const smallCaption = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.smallCaptionFontFamily};
    font-size: ${tokens.smallCaptionFontSize}px;
    line-height: ${tokens.smallCaptionLineHeight}px;
    color: ${tokens.smallCaptionFontColor};
`

const stepLabel = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.stepLabelFontFamily};
    font-size: ${tokens.stepLabelFontSize}px;
    line-height: ${tokens.stepLabelLineHeight}px;
    color: ${props => (props.color ? props.color : tokens.stepLabelFontColor)};
`

const offerPoints = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.offerPointsFontFamily};
    font-size: ${tokens.offerPointsFontSize}px;
    line-height: ${tokens.offerPointsLineHeight}px;
    color: ${props =>
        props.color ? props.color : tokens.offerPointsFontColor};
`

const tabHeader = css`
    ${uppercase};
    display: inline-block;
    font-family: ${tokens.tabHeaderFontFamily};
    font-size: ${tokens.tabHeaderFontSize}px;
    line-height: ${tokens.tabHeaderLineHeight}px;
    padding: ${tokens.tabHeaderVerticalPadding}px 0;
`

/* DEFAULT TEXTS */
export const BodyText = styled.span`
    display: inline-block;
    font-family: ${TEXT.FONT_FAMILY.DEFAULT_SANS};
    font-size: ${TEXT.FONT_SIZE.M};
    line-height: ${TEXT.LINE_HEIGHT.M};
    color: ${props => (props.color ? props.color : COLOR.PRIMARY)};

    ${({ center }) =>
        center &&
        `
            text-align: center;
        `};

    ${({ uppercase }) =>
        uppercase &&
        `
            text-transform: uppercase;
        `};

    ${({ capitalize }) =>
        capitalize &&
        `
            text-transform: capitalize;
        `};
`

export const CaptionText = styled.span`
    ${caption};
`

export const CaptionHintText = styled.span`
    ${caption};
`

export const ExtraSmallButtonText = styled.span`
    ${extraSmallButton};
`

export const SmallButtonText = styled.span`
    ${smallButton};
`

export const SmallCaptionText = styled.span`
    ${smallCaption};
`

/* CUSTOM TEXTS */
export const BodyUppercaseText = styled.span`
    ${body};
`

export const CaptionHintAccentuationText = styled.span`
    ${caption};
    color: ${colors.accentuation};
`

export const CaptionHintLightBrownText = styled.span`
    ${caption};
    color: ${colors.lightBrown};
`

export const CaptionHintError = styled.span`
    ${caption};
    color: ${tokens.errorFontColor};
`

export const StepLabelText = styled.span`
    ${stepLabel};
`

export const TabHeaderActiveText = styled.span`
    ${tabHeader};
    color: ${tokens.tabHeaderActiveFontColor};
`

export const TabHeaderInactiveText = styled.span`
    ${tabHeader};
    color: ${tokens.tabHeaderInactiveFontColor};
`

export const OfferPointsText = styled.span`
    ${offerPoints};
`

export const SmallText = styled.span`
    ${smallText};
`

export const SmallTextLightBrown = styled.span`
    ${smallText};
    color: ${colors.lightBrown};
`

export const SmallTextCrunchyGreen = styled.span`
    ${smallText};
    color: ${colors.crunchyGreen};
`

export const SmallTextFieryRed = styled.span`
    ${smallText};
    color: ${colors.fieryRed};
`

export const SmallTextGreyBbqBrown = styled.span`
    ${smallText};
    color: ${colors.greyBbqBrown};
`
